import { TableWrapper } from './helpersComponents'

const NewsletterContentImageButton = ({linkUrl, linkText, linkColor, backgroundColor, buttonWidth, borderRadius = false, tdStyles, stylesText={}, align="left", borderColor = false}) => (
    <td align={align} style={tdStyles}>
        <TableWrapper className="tinyButton" width={buttonWidth} style={{
            borderSpacing: 0,
            borderCollapse: 'separate',
            backgroundColor: backgroundColor, 
            border: `1px solid ${borderColor ? borderColor : backgroundColor}`, 
            ... (borderRadius && {borderRadius: borderRadius})
        }}>
            <tr>

                <td align="center" valign="top" style={{padding: "0 2px"}}>
                    <a href={linkUrl} target="_blank" style={{display: 'block', ...{color: linkColor,  textDecoration: "none"}, ...stylesText}}>
                        {linkText}
                    </a>
                </td>
            </tr>
        </TableWrapper>
    </td>

)

export default NewsletterContentImageButton